export default __webpack_public_path__ + "static/media/openview.0955d6e2.jpg";